const UBIGEO_DATA_BASE_URL = 'https://jmc-software-x.github.io/public-ubigeo-pe/data';

export type DepartmentOption = { id: string; name: string };
export type ProvinceOption = { id: string; name: string; departmentId: string };
export type DistrictOption = {
  id: string;
  name: string;
  provinceId: string;
  departmentId: string;
  inei: string;
};

type DepartmentResponse = {
  department: DepartmentOption;
  provinces: ProvinceOption[];
};

type ProvinceResponse = {
  department: DepartmentOption;
  province: { id: string; name: string };
  districts: DistrictOption[];
};

// Catálogo RENIEC usado por la fuente pública. Al seleccionar distrito se conserva
// también el código INEI de seis dígitos que devuelve el servicio.
export const DEPARTMENTS: readonly DepartmentOption[] = [
  { id: '01', name: 'Amazonas' },
  { id: '02', name: 'Áncash' },
  { id: '03', name: 'Apurímac' },
  { id: '04', name: 'Arequipa' },
  { id: '05', name: 'Ayacucho' },
  { id: '06', name: 'Cajamarca' },
  { id: '24', name: 'Callao' },
  { id: '07', name: 'Cusco' },
  { id: '08', name: 'Huancavelica' },
  { id: '09', name: 'Huánuco' },
  { id: '10', name: 'Ica' },
  { id: '11', name: 'Junín' },
  { id: '12', name: 'La Libertad' },
  { id: '13', name: 'Lambayeque' },
  { id: '14', name: 'Lima' },
  { id: '15', name: 'Loreto' },
  { id: '16', name: 'Madre de Dios' },
  { id: '17', name: 'Moquegua' },
  { id: '18', name: 'Pasco' },
  { id: '19', name: 'Piura' },
  { id: '20', name: 'Puno' },
  { id: '21', name: 'San Martín' },
  { id: '22', name: 'Tacna' },
  { id: '23', name: 'Tumbes' },
  { id: '25', name: 'Ucayali' },
];

async function fetchJson<T>(url: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(url, {
    headers: { Accept: 'application/json' },
    signal,
  });

  if (!response.ok) {
    throw new Error(`No se pudo consultar el ubigeo (HTTP ${response.status}).`);
  }

  return response.json() as Promise<T>;
}

export async function loadProvinces(departmentId: string, signal?: AbortSignal) {
  if (!/^\d{2}$/.test(departmentId)) return [];
  const data = await fetchJson<DepartmentResponse>(
    `${UBIGEO_DATA_BASE_URL}/departments/${departmentId}.json`,
    signal,
  );
  return [...data.provinces].sort((a, b) => a.name.localeCompare(b.name, 'es'));
}

export async function loadDistricts(provinceId: string, signal?: AbortSignal) {
  if (!/^\d{4}$/.test(provinceId)) return [];
  const data = await fetchJson<ProvinceResponse>(
    `${UBIGEO_DATA_BASE_URL}/provinces/${provinceId}.json`,
    signal,
  );
  return [...data.districts].sort((a, b) => a.name.localeCompare(b.name, 'es'));
}
